import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextField } from "@mui/material"
import { makeStyles } from "@mui/styles";
import DatePickerMonitoring from "components/DatePickers/DatePickerMonitoring/DatePickerMonitoring";
import CustomDialog from "components/Dialogs/MasterDialog"
import FormMonitoring from "components/FormMonitoring"
import { CommonTexts, ContentFormsLabels, contentTexts } from "locale/es"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "redux/reducers/notificationReducer";
import { AppColors } from "resources/AppColors"
import ContentService from 'services/ContentService'

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: AppColors.PRIMARY,
      },
    },
    "& .MuiInputBase-root": {
      color: AppColors.PRIMARY,
    },
    "& .MuiInputLabel-root": {
      color: AppColors.PRIMARY,
    },
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
  },
}));

function AssociateContentForm() {
  const [selectedPatients, setSelectedPatients] = useState([])
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const { entityId } = useLocation().state

  const dispatch = useDispatch()

  const navigate = useNavigate()

  const classes = useStyles();

  const allPatients = useSelector(({ allPatients }) => allPatients.data)

  async function handleOnConfirmAssociateContent(e) {
    e.preventDefault()
    const newAssociation = {
      contentId: entityId,
      startDate,
      endDate,
      patientList: selectedPatients.map(patient => patient.id)
    }
    try {
      await ContentService.associateContentAndPatient(newAssociation)
      dispatch(toast(contentTexts.ASSOCIATED, 'success'))
      handleShowExitModal()
    }
    catch (error) {
      console.error(error)
      dispatch(toast(contentTexts.ASSOCIATION_ERROR, 'error'))
    }
  }

  function resetFormInputs() {
    setSelectedPatients([])
    setStartDate(null)
    setEndDate(null)
  }

  function handleSelectPatients(event) {
    const {
      target: { value },
    } = event;

    if (value[value.length - 1] === "all") {
      setSelectedPatients(selectedPatients.length === allPatients.length ? [] : allPatients);
      return;
    }

    setSelectedPatients(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  }

  function handleStartDate(dateObject) {
    setStartDate(dateObject);
  }

  function handleEndDate(dateObject) {
    setEndDate(dateObject);
  }

  function handleShowExitModal() {
    navigate('/contingut/management')
  }

  return (
    <CustomDialog
      title={contentTexts.ASSOCIATE_PATIENT}
      show={true}
      handleShow={handleShowExitModal}
    >
      <FormMonitoring
        submitForm={handleOnConfirmAssociateContent}
        resetFormInputs={resetFormInputs}
        isEdit
      >
        <Box fullwidth='true' sx={{ display: 'flex', justifyContent: 'space-around' }}>
          <Box sx={{ maxWidth: 160 }}>
            <DatePickerMonitoring
              value={startDate}
              setValue={handleStartDate}
              label={ContentFormsLabels.START_DATE}
              maxDate={endDate}
            />
          </Box>
          <Box sx={{ maxWidth: 160 }}>
            <DatePickerMonitoring
              value={endDate}
              setValue={handleEndDate}
              label={ContentFormsLabels.END_DATE}
              minDate={startDate}
            />
          </Box>
        </Box>
        <FormControl required sx={{ mt: 2, mb: 1 }} className={classes.textFieldLabel}>
          <InputLabel id="select-patients-label">{CommonTexts.PATIENTS}</InputLabel>
          <Select
            labelId="patient-selector-label"
            id="patients-selector"
            variant="outlined"
            value={selectedPatients}
            label={CommonTexts.PATIENTS}
            onChange={handleSelectPatients}
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            multiple
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value.id} label={value.fullName} />
                ))}
              </Box>
            )}
          >
            <MenuItem value='all'>
              <em><strong>{contentTexts.SELECT} {CommonTexts.PATIENTS}</strong></em>
            </MenuItem>
            {allPatients.map(patient => <MenuItem key={patient.id} value={patient}>{patient.fullName}</MenuItem>
            )}
          </Select>
        </FormControl>
      </FormMonitoring>
    </CustomDialog>
  )
}

export default AssociateContentForm